// ==========================================================================
// 1. WEB-COMPONENT: INHALTSVERZEICHNIS (MAG-TOC)
// ==========================================================================

class MagTableOfContents extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    window.requestAnimationFrame(() => {
      const contentArea = document.querySelector('.mag-content-render');
      if (!contentArea) return;

      const headings = Array.from(contentArea.querySelectorAll('h2'));
      if (!headings.length) return;

      this.render(headings);
      this.bindEvents();
    });
  }

  render(headings) {
    const toc = document.createElement('div');
    toc.className = 'mag-toc';

    const title = document.createElement('div');
    title.className = 'mag-toc__title';
    title.textContent = 'INHALT';

    const list = document.createElement('ul');
    list.className = 'mag-toc__list';

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = `mag-heading-${index + 1}`;
      }

      const item = document.createElement('li');
      item.className = 'mag-toc__item';

      const link = document.createElement('a');
      link.className = 'mag-toc__link';
      link.href = `#${heading.id}`;

      const number = document.createElement('span');
      number.className = 'mag-toc__num';
      number.textContent = String(index + 1).padStart(2, '0');

      const text = document.createElement('span');
      text.className = 'mag-toc__text';
      text.textContent = heading.textContent.trim();

      link.append(number, text);
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.append(title, list);
    this.replaceChildren(toc);
  }

  bindEvents() {
    this.addEventListener('click', (event) => {
      const link = event.target.closest('.mag-toc__link');
      if (!link) return;

      const targetId = link.getAttribute('href');
      if (!targetId || !targetId.startsWith('#')) return;

      const targetElement = document.getElementById(targetId.slice(1));
      if (!targetElement) return;

      event.preventDefault();

      const offset = 120;
      const top = targetElement.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });
  }
}

if (!customElements.get('mag-toc')) {
  customElements.define('mag-toc', MagTableOfContents);
}

document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('[data-mag-product-slider]');
  if (!slider) return;

  const section = slider.closest('.mag-product-slider-section');
  if (!section) return;

  const prevButton = section.querySelector('.mag-product-slider__button--prev');
  const nextButton = section.querySelector('.mag-product-slider__button--next');

  if (!prevButton || !nextButton) return;

  function getScrollAmount() {
    const card = slider.querySelector('.mag-slider-card');
    if (!card) return slider.clientWidth;

    const gap = Number.parseFloat(window.getComputedStyle(slider).gap) || 36;
    return card.offsetWidth + gap;
  }

  function updateButtons() {
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    prevButton.disabled = slider.scrollLeft <= 2;
    nextButton.disabled = slider.scrollLeft >= maxScroll - 2;
  }

  prevButton.addEventListener('click', () => {
    slider.scrollBy({
      left: -getScrollAmount(),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });

  nextButton.addEventListener('click', () => {
    slider.scrollBy({
      left: getScrollAmount(),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });

  slider.addEventListener('scroll', () => {
    window.requestAnimationFrame(updateButtons);
  }, { passive: true });

  window.addEventListener('resize', updateButtons);

  updateButtons();
});